import React from "react";
import { Button } from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { Link } from "react-router-dom";
import {
  CreateButton,
  Datagrid,
  ExportButton,
  List,
  TextField,
  TopToolbar,
  useLocaleState,
  useTranslate,
} from "react-admin";

// Replacing <List>'s default actions loses the Create/Export buttons it
// normally renders, so they're re-added here alongside the new one.
const ServicesListActions = () => {
  const translate = useTranslate();
  return (
    <TopToolbar>
      <Button
        component={Link}
        to="/services/reorder"
        startIcon={<SwapVertIcon />}
        size="small"
      >
        {translate("servicesReorder.menu")}
      </Button>
      <CreateButton />
      <ExportButton />
    </TopToolbar>
  );
};

const ServicesList = () => {
  const [locale] = useLocaleState();

  return (
    <List pagination={false} actions={<ServicesListActions />}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField
          label="services.serviceName"
          source={`serviceName.${locale}`}
        />
      </Datagrid>
    </List>
  );
};

export default ServicesList;
